module.exports = __webpack_public_path__ + "static/media/Template_8.e9183ae0.png";